import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import Basic_394146786, { _demoInfo as Basic_394146786_demoInfo } from "../../../../../packages/console-tree-graph/demo/Basic.tsx?loadDemo";
import React from 'react';
export default {
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  Basic_394146786,
  Basic_394146786_demoInfo,
  React
};